<script lang="ts">
	import { VideoCard } from '$global/components/VideoCard';

	interface Props {
		dataCy: string;
		relatedVideos: {
			href: string;
			title: string;
			image: string;
			duration: string;
			description: string;
			id: string;
		}[];
	}

	let { dataCy, relatedVideos }: Props = $props();
	let dataCyPrefix = $derived(`${dataCy}-related-talks-mobile`);
</script>

<div
	data-cy={dataCyPrefix}
	class="xs:grid-cols-1 grid gap-4 sm:grid-cols-2 md:grid-cols-3 lg:hidden"
>
	{#each relatedVideos as relatedVideo}
		<VideoCard
			variant="light"
			duration={relatedVideo.duration}
			src={relatedVideo.image}
			title={relatedVideo.title}
			description={relatedVideo.description}
			href={relatedVideo.href}
			dataCy={`${dataCyPrefix}-${relatedVideo.id}`}
		/>
	{/each}
</div>
